'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Utils


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UserAccessEntry = require('./UserAccessEntry');

var _UserAccessEntry2 = _interopRequireDefault(_UserAccessEntry);

var _Spinner = require('../../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _RetryErrorComponent = require('../../../../../components/error/RetryErrorComponent');

var _RetryErrorComponent2 = _interopRequireDefault(_RetryErrorComponent);

var _userUtil = require('../../../../../user/userUtil');

var _userConstants = require('../../../../../../common/users/userConstants');

require('./UserAccessList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        elements: state.get('elements'),
        currentUserId: state.getIn(['app', 'currentUser', '_id'])
    };
};

var userAccessSortingFn = function userAccessSortingFn(userAccessA, userAccessB) {
    // Current user on top
    if (userAccessA.isCurrentUser) return -1;
    if (userAccessB.isCurrentUser) return 1;

    // Remotely active users higher than non-active
    if (userAccessA.currentlyViewing && !userAccessB.currentlyViewing) return -1;
    if (userAccessB.currentlyViewing && !userAccessA.currentlyViewing) return 1;

    // Editable users higher than non-editable
    if (userAccessA.editable && !userAccessB.editable) return -1;
    if (userAccessB.editable && !userAccessA.editable) return 1;

    // Active users higher than invited
    if (userAccessA.user.get('status') === _userConstants.USER_STATUSES.ACTIVE && !userAccessB.user.get('status') === _userConstants.USER_STATUSES.ACTIVE) return -1;
    if (userAccessB.user.get('status') === _userConstants.USER_STATUSES.ACTIVE && !userAccessA.user.get('status') === _userConstants.USER_STATUSES.ACTIVE) return 1;

    // Online users higher than offline
    if (userAccessA.online && !userAccessB.online) return -1;
    if (userAccessB.online && !userAccessA.online) return 1;

    // Sorted finally by name
    return userAccessA.name.localeCompare(userAccessB.name);
};

var UserAccessList = function UserAccessList(props) {
    var boardPermissions = props.boardPermissions,
        currentBoardId = props.currentBoardId,
        sharedUsers = props.sharedUsers,
        currentUserId = props.currentUserId,
        usersCurrentlyViewing = props.usersCurrentlyViewing,
        elements = props.elements,
        sharedUserIds = props.sharedUserIds,
        isLoading = props.isLoading,
        isUserError = props.isUserError;


    if (isUserError) {
        var retryFn = function retryFn() {
            return props.fetchUsers(sharedUserIds);
        };
        return _react2.default.createElement(
            'div',
            { className: 'UserAccessList error' },
            _react2.default.createElement(_RetryErrorComponent2.default, { message: 'There was a problem loading users', retryFn: retryFn })
        );
    }

    if (isLoading) {
        return _react2.default.createElement(
            'div',
            { className: 'UserAccessList loading' },
            _react2.default.createElement(_Spinner2.default, { show: true })
        );
    }

    var userAccessArray = sharedUsers.reduce(function (userArrayAcc, user) {
        var userId = user.get('_id');
        var isCurrentUser = userId === currentUserId;
        var permission = boardPermissions[userId].permission;
        var boardId = boardPermissions[userId].elementId;
        var name = (0, _userUtil.getDisplayName)(user);
        var currentlyViewing = usersCurrentlyViewing.has(userId);
        var online = (0, _userUtil.isOnline)(user);

        var accessDetails = {
            userId: userId,
            isCurrentUser: isCurrentUser,
            user: user,
            name: name,
            permission: permission,
            currentlyViewing: currentlyViewing,
            online: online,
            editable: boardId === currentBoardId,
            sharedBoard: elements.get(boardId)
        };

        userArrayAcc.push(accessDetails);
        return userArrayAcc;
    }, []).sort(userAccessSortingFn);

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('UserAccessList users', { empty: sharedUsers.size <= 1 }) },
        _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
                transitionName: 'glow',
                transitionEnterTimeout: 1000,
                transitionLeaveTimeout: 1 },
            userAccessArray.map(function (userAccess) {
                return _react2.default.createElement(_UserAccessEntry2.default, _extends({ key: userAccess.userId }, userAccess, { currentBoardId: currentBoardId }));
            })
        )
    );
};

UserAccessList.propTypes = {
    sharedUsers: _propTypes2.default.object,
    boardPermissions: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string,
    currentUserId: _propTypes2.default.string,
    usersCurrentlyViewing: _propTypes2.default.object,
    activeUsers: _propTypes2.default.object,
    elements: _propTypes2.default.object,
    fetchUsers: _propTypes2.default.func,
    isUserError: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    sharedUserIds: _propTypes2.default.array
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(UserAccessList);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/userAccessList/UserAccessList.js
// module id = 2198
// module chunks = 0